const FIFTEEN_MINUTES_IN_SECONDS = 15 * 60;

export const AGGREGATED_METRICS_API_SHARED_SETTINGS = {
  keepUnusedDataFor: FIFTEEN_MINUTES_IN_SECONDS,
};
